import type { SelectedBB } from 'types/story';
import { SET_EDITABLE_EDITOR_ELEMENT } from 'admin/constants/actions';

export function setEditableEditorElement(elements: SelectedBB) {
	return {
		type: SET_EDITABLE_EDITOR_ELEMENT,
		payload: elements,
	};
}
